export type Job = { url: string; title: string; location: string; workmode: string; salary: string; skills: string[]; category: string; slug?: string; hot?: boolean };
export const JJIT_SNAPSHOT: Job[] = [
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-analityk-systemowy-ekosystem-kasowy--poznan-data",
    "title": "Systems Analyst (Cash Ecosystem)",
    "location": "Poznań",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "Amplitude",
      "UML",
      "BPMN"
    ],
    "category": "Data"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-analityk-systemowy-she-he-they--poznan-data",
    "title": "Systems Analyst (she/he/they)",
    "location": "Poznań",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "Amplitude",
      "UML",
      "BPMN"
    ],
    "category": "Data"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-data-product-owner-she-he-they--poznan-pm-89c06408",
    "title": "Data Product Owner (she/he/they)",
    "location": "Poznań",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "Scrum",
      "SQL"
    ],
    "category": "Product"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-data-scientist-she-he-they--warszawa-data-ecc29b5b",
    "title": "Data Scientist (she/he/they)",
    "location": "Warszawa",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "scikit-learn",
      "SQL",
      "Python"
    ],
    "category": "Data"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-java-developer-she-he-they--poznan-java",
    "title": "Java Developer (she/he/they)",
    "location": "Poznań",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "Git",
      "JUnit",
      "TestFX",
      "Turn on job alerts"
    ],
    "category": "Programming"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-lead-data-scientist-she-he-they--poznan-data",
    "title": "Lead Data Scientist (she/he/they)",
    "location": "Poznań",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "Machine Learning",
      "SQL",
      "Python"
    ],
    "category": "Data"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-lead-genai-engineer-she-he-they--poznan-data",
    "title": "Lead GenAI Engineer (she/he/they)",
    "location": "Poznań",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "LLM",
      "Gen AI",
      "Azure"
    ],
    "category": "Data"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-lead-machine-learning-engineer-she-he-they--poznan-data-526b8f16",
    "title": "Lead Machine Learning Engineer (she/he/they)",
    "location": "Poznań",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "Machine Learning",
      "SQL",
      "Python"
    ],
    "category": "Data"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-machine-learning-engineer-genai-she-he-they--poznan-ai-c5811d74",
    "title": "Machine Learning Engineer (GenAI) (she/he/they)",
    "location": "Poznań",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "GenAI",
      "Python"
    ],
    "category": "AI / ML"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-machine-learning-engineer-she-he-they--warszawa-ai-f4322a6a",
    "title": "Machine Learning Engineer (she/he/they)",
    "location": "Warszawa",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "scikit-learn",
      "SQL",
      "Python"
    ],
    "category": "AI / ML"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-product-data-analyst-she-he-they--poznan-analytics",
    "title": "Product Data Analyst (she/he/they)",
    "location": "Poznań",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "MS Excel",
      "SQL",
      "Python"
    ],
    "category": "Analytics"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-product-designer-she-he-they--poznan-ux",
    "title": "Product Designer (she/he/they)",
    "location": "Poznań",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "MIRO",
      "Amplitude/Mixpanel",
      "Figma"
    ],
    "category": "Design"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-product-owner-retail-space--poznan-analytics",
    "title": "Product Owner (Retail Space)",
    "location": "Poznań",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "Power BI",
      "Confluence",
      "Jira"
    ],
    "category": "Analytics"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-qa-automation-engineer-she-he-they--poznan-testing-c36220f1",
    "title": "QA Automation Engineer (she/he/they)",
    "location": "Poznań",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "Cucumber",
      "Git",
      "JUnit"
    ],
    "category": "QA"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-solutions-architect-ekosystem-kasowy--poznan-architecture",
    "title": "Solutions Architect (Cash Ecosystem)",
    "location": "Poznań",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "PostreSQL",
      "C#",
      "CI/CD"
    ],
    "category": "Architecture"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-solutions-architect-platforma-cyberstore--poznan-devops",
    "title": "Solutions Architect (Cyberstore Platform)",
    "location": "Poznań",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "PostreSQL",
      "C#",
      "CI/CD"
    ],
    "category": "DevOps"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-senior-software-engineer-machine-learning---mlops--krakow-python",
    "title": "Senior Software Engineer (Machine Learning - MLOps)",
    "location": "Kraków",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "Cloud",
      "Kubernetes",
      "Python"
    ],
    "category": "AI / ML"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-software-engineer---backend-colleague-clubcard-api--krakow-java",
    "title": "Software Engineer - Backend (Colleague Clubcard API)",
    "location": "Kraków",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "Microservices",
      "Azure",
      "Terraform"
    ],
    "category": "Programming"
  },
  {
    "url": "https://justjoin.it/job-offer/green-hive-technology-software-engineer---fullstack-fulfilment--krakow-java",
    "title": "Software Engineer - Fullstack (Fulfilment)",
    "location": "Kraków",
    "workmode": "Remote",
    "salary": "Undisclosed Salary",
    "skills": [
      "Microservices",
      "Azure",
      "REST API"
    ],
    "category": "Programming"
  },
  {
    "url": "internal://positive-recruitment/senior-software-engineer-full-stack",
    "title": "Senior Software Engineer - Full Stack",
    "location": "Warszawa",
    "workmode": "On-site",
    "salary": "do 40 000 PLN netto (B2B)",
    "skills": [
      "TypeScript",
      "React",
      "Svelte",
      "Next.js",
      "SQL",
      "PostgreSQL"
    ],
    "category": "Programming",
    "hot": true
  },
  {
    "url": "internal://positive-recruitment/senior-java-engineer",
    "title": "Senior Java Engineer",
    "location": "Remote",
    "workmode": "Remote",
    "salary": "do 38k nett na B2B",
    "skills": [
      "Java",
      "Spring Boot",
      "Kafka",
      "PostgreSQL",
      "AWS"
    ],
    "category": "Programming",
    "hot": true
  },
  {
    "url": "internal://positive-recruitment/data-architect",
    "title": "Data Architect",
    "location": "Remote",
    "workmode": "Remote",
    "salary": "do 40k nett na B2B",
    "skills": [
      "SQL",
      "BigQuery",
      "Snowflake",
      "GCP",
      "Azure",
      "Data Governance",
      "ETL/ELT",
      "Data Modeling",
      "Cloud"
    ],
    "category": "Architecture",
    "hot": true
  },
  {
    "url": "internal://positive-recruitment/senior-qa-engineer",
    "title": "Senior QA Engineer",
    "location": "Remote",
    "workmode": "Remote",
    "salary": "B2B, based on seniority",
    "skills": [
      "Playwright",
      "TypeScript",
      "REST API"
    ],
    "category": "QA",
    "hot": true
  },
  {
    "url": "internal://positive-recruitment/senior-software-engineer-llms-python",
    "title": "Senior Software Engineer (LLMs, Python)",
    "location": "Remote",
    "workmode": "Remote",
    "salary": "from 20k PLN net (B2B)",
    "skills": [
      "Python",
      "LLM",
      "SQL"
    ],
    "category": "AI / ML",
    "hot": true
  }
] ;
